import React, { useEffect, useState } from "react";
import "./WinnersAboutUs.css";
import { useInView } from "react-intersection-observer";
import img from "../../Images/Rectangle 20 (2).png";

const Counter = ({ end, label }) => {
  const [count, setCount] = useState(0);
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  useEffect(() => {
    if (inView) {
      let start = 0;
      const duration = 2000; // total duration of animation in ms
      const incrementTime = 15;
      const increment = Math.ceil(end / (duration / 20));

      const counter = setInterval(() => {
        start += increment;
        if (start >= end) {
          setCount(end);
          clearInterval(counter);
        } else {
          setCount(start);
        }
      }, 20);
    }
  }, [inView, end]);

  return (
    <div className="achievement_box" ref={ref}>
      <p className="achieve_number_para">{count.toLocaleString()}+</p>
      <p className="achive_name">{label}</p>
    </div>
  );
};
const Achievements = () => {
  return (
    <>
      <section className="achievements_section2">
        <div className="achievements_wrapper">
          <div className="achievements_details">
            <Counter end={25000} label="Happy Client" />
            <Counter end={350} label="Complete Projects" />
            <Counter end={80000} label="Property Sales" />
            <Counter end={15} label="Years Experience" />
          </div>

          <div className="achievement_images_div_wrapper">
            <div className="achievement_img_div">
              <img
                src={img}
                style={{
                  width: "100%",
                  height: "100%",
                }}
              ></img>
              <div className="achieve_white_box_div">
                <p className="featured_para5">Featured projects</p>
                <p className="featured_para6">
                  Lorem Ipsum placeholder text for use in your graphic, print
                  and web layouts, and discover plugins
                </p>
                <button className="featured_see_more_btn">See More</button>
              </div>
            </div>
            <div className="achievement_content_div">
              <h2>
                Real Estate Without the <br />
                Hassle
              </h2>
              <p className="para1">
                Lorem Ipsum placeholder text for use in your graphic, print and
                web layouts, and discover plugins for your favorite writing,
                design and blogging tools. Explore the origins, history and
                meaning of the famous passage Lorem Ipsum placeholder text for
                use in your graphic, print and web layouts, and discover plugins
                for your favorite writing, design and blogging tools. Explore
                the origins, history and meaning of the famous passage
              </p>
              <p className="para1 mt-2">
                Lorem Ipsum placeholder text for use in your graphic, print and
                web layouts, and discover plugins for your favorite writing,
                design and blogging tools. Explore the origins, history and
                meaning of the famous passage.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Achievements;
